// @flow
import apiFetch from 'api/fetch';

type Props = { clientId: Id, profileId: Id, ugcId: Id };

export const createUgcAssignment = (token: string, props: Props) => {
  const { clientId, profileId, ugcId } = props;
  const fetchUrl = `/cdm/ugc/assign/${ugcId}`;
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify({
      ugcId,
      client_id: clientId,
      target_profile_id: profileId,
    }),
  };

  return apiFetch(fetchUrl, fetchOptions);
};

export const deleteUgcAssignment = (token: string, props: Props) => {
  const { clientId, ugcId } = props;
  const fetchUrl = `/cdm/ugc/assign/${ugcId}`;
  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify({
      client_id: clientId,
    }),
  };

  return apiFetch(fetchUrl, fetchOptions);
};

export default (token: string, props: Props) => {
  return props.profileId != null
    ? createUgcAssignment(token, props)
    : deleteUgcAssignment(token, props);
};



// WEBPACK FOOTER //
// ./src/containers/client/ugcAssignmentApi.js